export default {
  id : 'ps.StationTimelineQueryHandler',
  matches : {
    objectType : 'station',
    client : 'ps.StationTimelineEvents'
  },
  handle( cxt ) {
    const { clientProps : { paginator } } = cxt
    const stationIds = paginator.pageItems.map( item => item.id )

    return {
      where : [
        [ '$data/analyticsType', '=', 'occupancy' ],
        [ '$data/featureDevice/deviceId', 'IN', stationIds ]
      ],
      order : [
        [ '$time', 'ASC' ]
      ]
    }
  }
}
